import { useTranslation } from 'react-i18next'
import { DataItem } from 'scrivito'

import { Button } from '@/Atomic/Molecules/Button'
import { SublistItem, SublistItemContent } from '@/Atomic/Templates/Sublist'
import { showUnlinkToast } from '@/Atomic/Widgets/Toasts/UnlinkToast'
import { getActivityTypeIcon } from '@/Components/Activity/getActivityTypeIcon'
import { useUndoableAction } from '@/hooks/useUndoableAction'
import { getDataItemTitle } from '@/utils/dataClassMap'

interface FollowUpSublistItemProps {
  followUp: DataItem
  flash?: boolean
  getTypeTitle: (typeValue: string) => string
  onOpenFollowUp: (followUp: DataItem) => void
}

export const FollowUpSublistItem: React.FC<FollowUpSublistItemProps> = ({
  followUp,
  flash,
  getTypeTitle,
  onOpenFollowUp,
}) => {
  const { t } = useTranslation()
  const typeValue = (followUp.get('type') as string) || ''
  const typeTitle = getTypeTitle(typeValue)
  const title = getDataItemTitle(followUp) || undefined
  const { isHidden, run } = useUndoableAction()

  const handleUnlink = () => {
    const followUpId = followUp.id()

    run({
      id: followUpId,
      onAction: ({ onError, onUndo }) =>
        showUnlinkToast({
          dataItem: followUp,
          onCommit: () => followUp.update({ origin: '' }),
          onError,
          onUndo,
        }),
    })
  }

  if (isHidden(followUp.id())) return null

  return (
    <SublistItem flash={flash}>
      <SublistItemContent
        avatarIcon={getActivityTypeIcon(typeValue)}
        title={title}
        subtitle={typeTitle}
        onClick={() => onOpenFollowUp(followUp)}
        showButton="onHover"
        button={
          <Button
            variant="icon"
            icon="cross"
            tooltip={t('common.remove')}
            onClick={handleUnlink}
          />
        }
      />
    </SublistItem>
  )
}
